module.exports = __webpack_public_path__ + "static/img/expellinginsects-active.bd2f79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/expellinginsects-active.png
// module id = 5arC
// module chunks = 58